import { Component, OnInit } from '@angular/core';
import {NgbModal } from '@ng-bootstrap/ng-bootstrap'; //, ModalDismissReasons
import { FormBuilder, Validators} from '@angular/forms'; //FormGroup, FormControl,
import { Router } from '@angular/router'; //, NavigationExtras

import { SigninUpComponent } from '../signin-up/signin-up.component';

// PROVIDER
import {BasicProvider} from '../providers/basic/basic';
import {UserProvider} from '../providers/user/user';

@Component({
  selector: 'app-home-header',
  templateUrl: './home-header.component.html',
  styleUrls: ['./home-header.component.css']
})

export class HomeHeaderComponent implements OnInit {

  countries:any;
  isCollapsed = true;
  closeResult: string;
  airfrightForm;
  calculated_price;
  isDisabled = true;
  isShowLoading = false;
  calculation_error='';

  constructor(
    private modalService: NgbModal,
    public builder:FormBuilder,
    public bp:BasicProvider, 
    public up:UserProvider,
    public router: Router,
  ) {
    this.airfrightValidate();
  }

  
  airfrightValidate() {
    this.airfrightForm = this.builder.group({
      country_id: ['', Validators.compose([this.bp.required])],
      weight: ['', Validators.compose([this.bp.required])], 
      length: ['', Validators.compose([this.bp.required])], 
      width: ['', Validators.compose([this.bp.required])], 
      height: ['', Validators.compose([this.bp.required])], 
    });
  }

  async airfrightSubmit() {
    var validation_message = {
      'country_id': {
        'required': 'Please select country.',
      },
      'weight': {
        'required': 'Please enter weight.',
      },
      'length': {
        'required': 'Please enter length.',
      }, 
      'width': {
        'required': 'Please enter width.'
      },
      'height': {
        'required': 'Please enter height.'
      }
    };
    if (this.bp.validation(this.airfrightForm, validation_message)) {
      this.calculation_error ='';
      let submitData = this.airfrightForm.value;
      //console.log(submitData);
      var data = Object.assign({}, submitData);
      this.isShowLoading = true;
      this.bp.hitApi('settings/calculateFreightCharge', 'POST', data)
        .subscribe(
          success => {
            if (success.type == true) {
                this.isShowLoading = false;
                this.calculated_price = success.message;
                
            } else {
              this.bp.showAlert(success.message,  'OK', () => { });
            }
          }, 
          error => {

          }
        );

    } else {
      this.calculation_error = this.bp.validation_error;
    }
  }

  signupOpen(content) {
    this.bp.model_type = 'signup';
    this.bp.model = this.modalService.open(SigninUpComponent, { windowClass: 'signUp-modal' });
    return false;
  }

  toggleMenu() {
    this.isCollapsed = !this.isCollapsed;
  }

  ngOnInit() {
    this.getData();
  }

  getData(){
    if(true|| !this.up.isContryData){
      this.bp.hitApi('settings/get_country_island', 'GET', {},true)
      .subscribe(
        success => { 
          if( success.type == true ){ 
            console.log(success.data);
            this.up.countryData = success.data; 
            this.countries = this.up.getCountry(); 
            this.up.setSocialData(success.social_url);
          }
          else {
            this.bp.showAlert(success.message, 'OK', () => {
              
            }); 
          } 
        }, 
        error => {
          console.log(error);
        }
      );
    }
    else{
      //this.countries = this.up.getCountry();
    }
  }

  

  


  

  

}



// WEBPACK FOOTER //
// ./src/app/home-header/home-header.component.ts